import axios from "axios";

import { useDispatch } from "react-redux";
import API_BASE_URL from "../BaseURL/baseURL";

// const dispatch = useDispatch();

export const fetchPartyDetailsEsign = async (pde_id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/PartyDetails/GetPartyDetails?pdeId=${pde_id}`
    );

    console.log(response.data);
    // Return the data directly
    return response.data;
  } catch (error) {
    // Throw a new error with the message from Axios error response
    throw new Error(error.response?.data?.message || "Failed to fetch data");
  }
};

export const sendEmailLinkToParties = async (payload) => {
  try {
    const response = await axios.post(
      "https://localhost:44369/Home/uploadpdf", // Ensure this endpoint is correct and accessible
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status < 200 || response.status >= 300) {
      throw new Error("Failed to send data");
    }

    return response.data;
  } catch (error) {
    // Log additional details for debugging
    if (error.response) {
      console.error("Server responded with a status:", error.response.status);
      console.error("Response data:", error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error setting up request:", error.message);
    }
    console.error("Error sending email link:", error);
    throw error;
  }
};

export const fetchesignStatus = async (pde_id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/PartyDetails/GetEsignStatus?PDEid=${pde_id}`
    );

    console.log(response.data);
    // Return the data directly
    return response.data;
  } catch (error) {
    // Throw a new error with the message from Axios error response
    throw new Error(error.response?.data?.message || "Failed to fetch data");
  }
};

export const checkEsignStatus = async (pde_id) => {
  try {
    const response = await axios.get(
      `https://localhost:44369/Home/ViewDoC?pde_id=${pde_id}`
    );

    console.log(response.data);
    // Return the data directly

    return response.data;
  } catch (error) {
    // Throw a new error with the message from Axios error response
    throw new Error(error.response?.data?.message || "Failed to fetch data");
  }
};
